import {viewModel as ExportCsvViewModel} from "./export.csv";
import {IAnchor, IObjectData} from "../../../index";
import {downloadCSV, getObjectDefinition, getSyncFieldValue} from "../../../util/misc";
import {moment} from 'moment';
import export_anchors_csvHtml from './export.anchors.csv.html?raw';

export let template = export_anchors_csvHtml;

interface IParams {

}

export class viewModel extends ExportCsvViewModel {
    protected override updateStep() {
        switch (this.step()) {
            case this.Step.Init:
                this.step(this.Step.Downloading);
                break;
            case this.Step.Success:
                this.messageData({message: `download completed`})
                break
            default:
                super.updateStep();
        }
    }

    protected override downloadCSV() {
        const keysObj: (keyof IObjectData)[] = [
            'id',
        ]
        const keysSyncfield = getObjectDefinition(this.objecttypeid)!.syncfieldDisplayName ?? [];
        const keysAnchor: (keyof IAnchor)[] = [
            'id',
            'anchor',
            'sourceid',
            'immutableid',
            'exporttemplateid',
            'deleted',
        ]

        const r = (val: any): string => val ? String(val).replace(/"/gm, '""') : "";

        let csv = [...keysObj,...keysSyncfield, ...keysAnchor].map(key => `"${key}"`).join(";") + '\n';
        this.data.forEach(obj => {
            if (!obj.anchor) {
                return
            }
            csv += obj.anchor.map(a => {
                return [
                    ...(keysObj.map(kO => r(obj[kO]))),
                    ...(keysSyncfield.map(kS => r(getSyncFieldValue(kS, obj.syncfields)))),
                    ...(keysAnchor.map(kA => r(a[kA]))),
                ]
                    .map(val => `"${val}"`)
                    .join(';') + '\n';
            }).join('');
        });

        downloadCSV(csv, this.getFileName());
    }

    protected override getFileName(): string {
        let ret: string = "eksport_av_ankere_for_";
        const objectTypeId = this.objecttypeid;
        ret += getObjectDefinition(objectTypeId)!.plural.toLowerCase();
        ret += "_"
            + moment().format('L').replace(/\//g, '-')
            + ".csv";
        return ret;
    }


}
